import React, { useEffect } from 'react';
import NotConnectedState from 'components/NotConnectedState';
import dashboardNotConnected from 'images/dashboard-not-connected.svg';
import emptyBox from 'images/empty-box.svg';
import AppRouter from 'common/AppRouter';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { useHistory } from 'react-router';

const NoDataDashboard = () => {
  const history = useHistory();
  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
      page: TRACKING.PAGES.DASHBOARD,
      page_tab: TRACKING.PAGE_TABS.EMPTY_STATE
    });
  }, []);

  return (
    <NotConnectedState
      notConnectedImg={dashboardNotConnected}
      title='No activity found'
      info={
        <>
          LinearB will work best for repos with recent branches and pull
          requests as it puts an emphasis on delivery metrics and bottleneck
          detection.
          <br /> <br /> It appears your repositories include very limited
          relevant activity. We recommend you replace or add other repositories{' '}
        </>
      }
      image={emptyBox}
      buttons={[
        {
          text: 'Add or edit repositories',
          onClick: () => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.DASHBOARD,
              page_tab: TRACKING.PAGE_TABS.EMPTY_STATE,
              click_type: TRACKING.CLICK.ADD_REPOS
            });

            history.push(`${AppRouter.REPOSITORIES.path}?isOrgSettings=true`);
          }
        }
      ]}
    />
  );
};

export default NoDataDashboard;
